import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import CustomLoader from 'components/CustomLoader/CustomLoader';

import './index.css';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';

const App = React.lazy(() => import('./App'));
const AppCo2 = React.lazy(() => import('./AppCo2'));

/*
 * React entry point
 */

// @ts-ignore
if (window.pfcCo2Tool !== undefined) {
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <Suspense fallback={<CustomLoader />}>
                    <AppCo2 />
                </Suspense>
            </Provider>
        </React.StrictMode>,
        document.getElementById('pfc-tool')
    );
} else {
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <Suspense fallback={<CustomLoader />}>
                    <App />
                </Suspense>
            </Provider>
        </React.StrictMode>,
        document.getElementById('root')
    );
}



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
